export const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.simplewallet.eu' 
  : (process.env.SERVER_URL || 'http://localhost');
export const API_URL = `${BASE_URL}/api`;
export const CLIENT_ID = '53436e0c-6a34-438f-a0b6-9460938c2839'
export const CLIENT_SECRET = '4c0b516b-7e59-426b-a7ba-2056523d3bd3'
export const RETRY_ATTEMPTS = 1